import { render, staticRenderFns } from "./AddUserOnFlowApproveModal.vue?vue&type=template&id=7f5d194f"
import script from "./AddUserOnFlowApproveModal.vue?vue&type=script&lang=ts"
export * from "./AddUserOnFlowApproveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports